import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// ctm
import { withQuoteFlatten } from '../common/with_quote_flatten';
import { PaymentFrequencyFilterDropdown } from '../../filters/common/payment_frequency_filter_dropdown';
import { DiscountOffer } from '../common/discount_offer';
import { ProductPrice } from '../common/product_price';
import { ProductPriceMonthlyNotice } from '../common/product_price_monthly_notice';
import { paymentFrequencyStateMapping, frequencyFilterTypes } from '../../filters/common/filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    container: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.primary50,
        borderRadius: theme.borderRadius.default,
        marginBottom: '0.8rem',
        paddingTop: theme.spacing[2],
        paddingBottom: theme.spacing[8]
    },
    priceAndFrequency: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: '2rem'
    },
    price: {
        display: 'flex'
    },
    frequency: {
        display: 'flex',
        marginTop: '6px'
    },
    dropdownButton: {
        fontSize: theme.fontSize.sm
    },
    priceMonthlyNotice: {
        marginTop: '-10px'
    }
}));

const _ProductPriceCardXs = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { productAnnualPremium, productMonthlyPremium, productMonthlyFirstMonth, productAnnualisedMonthlyPremium,
        quote, className, frequencyFilter } = props;

    return (
        <div className={classNames('test-policyProductCard-priceCard', classes.container, className)}>
            <div className={classes.priceAndFrequency}>
                <div className={classes.price}>
                    <ProductPrice
                        productAnnualPremium={productAnnualPremium}
                        productMonthlyPremium={productMonthlyPremium}
                    />
                </div>
                <div className={classes.frequency}>
                    <PaymentFrequencyFilterDropdown
                        className={classes.dropdownButton}
                        isWithoutLabel
                        options={{ annual: 'Annually', monthly: 'Monthly' }}
                    />
                </div>
            </div>
            {frequencyFilter === 'monthly' && (
                <div className={classes.priceMonthlyNotice}>
                    <ProductPriceMonthlyNotice
                        productMonthlyFirstMonth={productMonthlyFirstMonth}
                        productAnnualisedMonthlyPremium={productAnnualisedMonthlyPremium}
                    />
                </div>
            )}
            <DiscountOffer quote={quote} />
        </div>
    );
};

_ProductPriceCardXs.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,

    productAnnualPremium: PropTypes.number,
    productMonthlyPremium: PropTypes.number,
    productMonthlyFirstMonth: PropTypes.number,
    productAnnualisedMonthlyPremium: PropTypes.number,

    frequencyFilter: PropTypes.oneOf(frequencyFilterTypes)
};

const ProductPriceCardXs = withQuoteFlatten(connect(paymentFrequencyStateMapping, null)(_ProductPriceCardXs));


export { ProductPriceCardXs };
